import { NotebookPen } from "lucide-react";
import { BRAND_COLORS, withAlpha } from "../../lib/bookingStatus";

/**
 * Feb 2026 · Directive #299 · Read-only Anzeige der internen Anmerkung
 * direkt unter der Präferenzen-Karte in der Kunden-Detail-Ansicht.
 *
 * Zeigt strikt admin-only — der Parent-Screen rendert die Karte nur, wenn
 * `effectiveRole === "admin"`. Backend liefert `admin_note` für Concierges
 * bereits als `null`, sodass selbst ein rein clientseitig entwarfener
 * Frontend-Bypass keine Daten lecken kann.
 *
 * Nichts, wenn keine Notiz gesetzt ist — damit der Detail-Screen bei
 * Kunden ohne Anmerkung nicht mit einer leeren Karte aufgebläht wird.
 */
export function CustomerAdminNoteCard({ note }) {
  if (!note || !note.trim()) return null;
  return (
    <div
      className="mb-6 border-l-4 p-4 md:p-5"
      style={{
        borderLeftColor: BRAND_COLORS.gold,
        background: withAlpha(BRAND_COLORS.gold, 0.05),
      }}
      data-testid="customer-admin-note-card"
    >
      <div className="flex items-center gap-2 mb-2">
        <NotebookPen
          className="w-3.5 h-3.5"
          strokeWidth={1.8}
          style={{ color: BRAND_COLORS.goldDark }}
        />
        <span
          className="label-caps"
          style={{ color: BRAND_COLORS.goldDark }}
        >
          Interne Anmerkung
        </span>
        <span
          className="ml-auto text-[10.5px] tracking-widest uppercase text-navy-dark/45"
          title="Für den Kunden nicht sichtbar"
        >
          Admin-only
        </span>
      </div>
      <p
        className="text-[13.5px] text-navy-dark/85 leading-relaxed whitespace-pre-wrap"
        data-testid="customer-admin-note-text"
      >
        {note}
      </p>
    </div>
  );
}
